import React, { useEffect, useState } from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa6';
import WebSocketManager from '../manager/WebSocketManager';
import style from "./Rating.module.scss"
import { getUUID } from '../utils/uuid';
import { getSessionId, getThemeMode } from '../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { deleteLastMessage, setShowSenderComponent } from './Widget/store/actions';

function Rating({ message }) {
  const { widgetConfig } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
  }));
  const dispatch = useDispatch()
  const webSocketManager = new WebSocketManager();
  const [selectedRating, setSelectedRating] = useState(0);
  const [ratingText, setRatingText] = useState('');
  const [isBgLight, setIsBgLight] = useState(false);
  
  useEffect(() => {
    dispatch(setShowSenderComponent(true));
    setIsBgLight(getThemeMode(widgetConfig?.widgetConfig?.lookAndFeel?.backgroundColor))
  }, [])

  const handleStarClick = (rating) => {
    setSelectedRating((prev) => (prev === rating ? 0 : rating)); // Toggle rating
  };

  const handleChange = (event) => {
    setRatingText(event.target.value);
  };

  const handleSubmit = () => {
    const message = {
      id: getUUID(),
      sessionId: getSessionId(widgetConfig?.config?.widgetId),
      payloadType: 'event',
      type: 'rating',
      content: {
        text: ratingText,
        rating: selectedRating.toString()
      }
    };

    if (selectedRating >= 0) {
      dispatch(deleteLastMessage());
      webSocketManager.send(message);
      dispatch(setShowSenderComponent(false));
      const event = new CustomEvent("ratingSubmit", {
        detail: "Button was clicked!",
      });
      window.dispatchEvent(event);
    } else {
      alert('Please select a rating before submitting!');
    }
  };

  return (
    <div className={style.ratingClass}>
      <div className={style.ratingHeadStar}>
        <FaRegStar color={isBgLight ? '#000000' : '#ffffff'} style={{ background: widgetConfig?.widgetConfig?.lookAndFeel?.backgroundColor}} />
      </div>
      {/* Content */}
      <div className={style.ratingContent}>
        <h3 className={style.ratingTitle}>Rate your experience</h3>
        <p className={style.ratingSubtitle}>Are you satisfied with the service?</p>

        {/* Star Rating */}
        <div className={style.starRating}>
          {[1, 2, 3, 4, 5].map(
            (star) =>
              selectedRating >= star ? (
                <FaStar
                  onClick={() => handleStarClick(star)}
                  className={style.star}
                />
              ) : (
                <FaRegStar
                  onClick={() => handleStarClick(star)}
                  className={style.star}
                />
              )
          )}
        </div>
        <hr style={{ margin: '0 -20px', borderTop: '1px solid rgb(226, 232, 239)' }} />
        <h3 className={style.ratingTitleText}>Tell us what can be Improved</h3>
        <textarea
          placeholder="Tell us how we can improve..."
          value={ratingText}
          onChange={handleChange}
          className={style.ratingFormControl}
          rows="8"
        />
      </div>
      <div>
        <button className={style.rateSubmitButton} onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}

export default Rating;
